<div class="h-100">
  <div class="actionBar">
    <button *ngIf="isMonitor == false" class="default-btn borderedBtn" (click)="updateNetwork()">
      <span class="bi bi-pencil-square"></span>&nbsp;Edit
    </button>
  </div>
  <table
    class="table table-striped nodeNetworkDetailsTable"
    *ngIf="nodeNetwork"
    style="text-align: left; margin-bottom: 0px"
  >
    <tbody class="tableBody">
      <tr>
        <td>
          <span>IP Address</span> <span>{{ nodeNetwork.privateIp || "NA" }}</span>
        </td>
        <td>
          <span>External IP</span> <span>{{ nodeNetwork.publicIp  || "NA"}}</span>
        </td>
        <td>
          <span>IP Type</span> <span>{{ nodeNetwork.ipType || "NA" }}</span>
        </td>
      </tr>
      <tr class="active">
        <td>
          <span>DNS Name</span> <span>{{ nodeNetwork.dns || "NA" }}</span>
        </td>
        <td>
          <span>MAC Address</span> <span>{{ nodeNetwork.macAddress || "NA" }}</span>
        </td>
        <td >
          <span>Gateway</span> <span class="hpc-colon-divider">{{ nodeNetwork.gatewayName || "NA" }}</span>
          <!-- <i
            class="bi bi-pencil-square synchpc-primary fs-6 mx-2"
            (click)="
              attachGateway()
            "
            title="Update Gateway"
          ></i>
          <i
            class="bi bi-x-lg text-danger fs-6"
            *ngIf="nodeNetwork?.gateway"
            (click)="
              detachGateway()
            "
            title="Detach Gateway"
          ></i> -->
        </td>
      </tr>
    </tbody>
  </table>

  <ngx-spinner
    bdColor="rgba(0,0,0,0)"
    size="default"
    zIndex="1"
    color="var(--s-primary-color)"
    type="ball-spin"
    [fullScreen]="false"
    ><p class="pleaseWait">Please wait ...</p></ngx-spinner
  >
</div>
